import React, { FC } from 'react';
import {
  BackgroundImageProps,
  BasicContainer,
  BodyText,
  ButtonAsWrapper,
  FlexCol,
  FlexDynamic,
  FlexRow,
  TextDynamic,
} from '@minecraft.atoms';
import Icon from '@minecraft.icon';

export interface PromotionalBannerProps {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  ctaLabel: string;
  onClick: () => void;
  testId: string;
  ctaTestId?: string;
  heapId?: string;
  image: string;
  backgroundImageConfig?: Omit<BackgroundImageProps, 'image'>;
  mdProps?: {
    backgroundImageConfig?: Omit<BackgroundImageProps, 'image'>;
  };
}

export const PromotionalBanner: FC<PromotionalBannerProps> = ({
  title,
  subtitle,
  ctaLabel,
  onClick,
  testId,
  ctaTestId,
  heapId,
  image,
  backgroundImageConfig,
  mdProps,
}) => {
  return (
    <ButtonAsWrapper
      unsetSizing
      noPadding
      className="cn_w-full"
      aria-label={ctaLabel}
      data-testid={testId}
      data-heap-id={heapId}
      onClick={onClick}
    >
      <BasicContainer
        w="full"
        backgroundImage={{
          image,
          size: 'cover',
          position: 'center',
          repeat: 'no-repeat',
          ...backgroundImageConfig,
        }}
        mdProps={{
          backgroundImage: {
            image,
            size: 'cover',
            position: 'top',
            repeat: 'no-repeat',
            ...mdProps?.backgroundImageConfig,
          },
        }}
        className="cn_relative cn_overflow-hidden"
      >
        <FlexDynamic
          w="full"
          bgColor="maxContrast"
          bgOpacity={0.4}
          direction="column"
          alignItems="stretch"
          gap="3"
          className="cn_atom_px-4 cn_atom_py-4"
          mdProps={{
            direction: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '8',
            className: 'cn_atom_px-8 cn_atom_py-6',
          }}
        >
          <FlexCol gap="2">
            <TextDynamic
              color="inverted"
              fontSize="h3"
              fontWeight="semibold"
              mdProps={{ fontSize: 'h2', fontWeight: 'medium' }}
            >
              {title}
            </TextDynamic>
            <TextDynamic color="inverted" fontSize="bodySmall" mdProps={{ fontSize: 'bodyRegular' }}>
              {subtitle}
            </TextDynamic>
          </FlexCol>
          {/* Decorative CTA — not interactive; navigation is handled by ButtonAsWrapper */}
          <BasicContainer
            bgColor="goldPaywallSuccessBg"
            borderRadius="sm"
            w="full"
            mdProps={{ w: 'auto', minW: '60' }}
            className="cn_atom_px-4 cn_atom_py-2 cn_pointer-events-none cn_shrink-0"
            aria-hidden
            data-testid={ctaTestId}
          >
            <FlexRow alignItems="center" justifyContent="center" gap="2">
              <BodyText fontWeight="semibold" color="default">
                {ctaLabel}
              </BodyText>
              <Icon name="chevron-right-thick" size="sm" />
            </FlexRow>
          </BasicContainer>
        </FlexDynamic>
      </BasicContainer>
    </ButtonAsWrapper>
  );
};

export default PromotionalBanner;
